/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Grid, Typography, Button, Divider, useMediaQuery, useTheme, TextField, IconButton, FormControlLabel, Switch } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { CompanyServices, ICompany } from '../../../services/api/company/CompanyServices';
import { Clear, Search, Send, UploadFile } from '@mui/icons-material';
import ReactInputMask from 'react-input-mask';
import { useEffect, useState } from 'react';
import { helpers } from '../../../services/helpers/helpers';

interface CompanyFormProps {
    data: ICompany;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleSwitchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    fetchAdress: () => void;
    showAlert: (message: string, severity: 'success' | 'error' | 'warning' | 'info') => void;
    handleTabChange: (newValue: number) => void;
    setResponse: (newValue: ICompany) => void;
    handleClean: () => void;
}
export const CompanyForm = ({data, handleChange, handleFileChange, handleSwitchChange, fetchAdress, showAlert, handleTabChange, setResponse, handleClean}: CompanyFormProps) => {
    // onHandleCompany(initialData);

    const {id} = useParams();
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    const [ newForm, setNewForm ] = useState<boolean>(false);
    const [ error, setError ] = useState<boolean>(false);
    const [imageSrc, setImageSrc] = useState<string | undefined>(undefined);
    const navigate = useNavigate();

    useEffect(() => {
        if (data.image instanceof File) {
            const objectUrl = URL.createObjectURL(data.image);
            setImageSrc(objectUrl);
            return () => URL.revokeObjectURL(objectUrl);
        } else if (typeof data.image === 'string') {
            if (data.image.startsWith('/9j/') || data.image.startsWith('iVBORw0KGgoAAAANSUhEUg')) {
                setImageSrc(`data:image/jpeg;base64,${data.image}`);
            } else {
                setImageSrc(data.image);
            }
        } else {
            setImageSrc(undefined);
        }
    }, [data.image]);
    
    function verify(data: ICompany): boolean {
        return (
            data.nome != '',
            data.company_name != '',
            data.company_register != '',
            data.numero != '',
            data.pais != '',
            data.bairro != '',
            data.cep != '',
            data.cidade != '',
            data.rua != '',
            data.email != '',
            data.quantidade_barragens != 0,
            data.site != '',
            data.cep != '',
            data.rua != '',
            data.bairro != ''
        );
    }

    

    const handleSave = () => {
        const formattedCep = data.cep.replace('.', '');
        data.cep = formattedCep;
        const valid = verify(data);
        valid == true ? setError(false) : setError(true);
        
        if(id === 'novo' && data && valid){
            CompanyServices.create(data)
                .then((response) => {
                    if(response instanceof Error){
                        showAlert(`Erro ao salvar ! error :${response.message}`, 'error');
                    }else{
                        handleTabChange(1);
                        setResponse(response);
                    }
                });
        }else if(id !== 'novo' && data && id){
            if(!(data.image instanceof File) && data.image){
                data.image = helpers.base64ToImg(data.image);
            }
            CompanyServices.upgrade(id, data)
            .then((response) => {
                if(response instanceof Error){
                    showAlert(`Erro ao salvar ! error :${response.message}`, 'error');
                }else{
                    showAlert('Registro atualizado !', 'success');
                    setTimeout(() => {
                        navigate('/companies');
                    }, 1500);
                }
            });
        }
    };

    return (
        <Box width={'100%'}>
                <Grid container flex={1} spacing={1}>
                        <Grid item xs={8}>
                            <Typography variant='h5'> Cadastro de Empresa</Typography>
                        </Grid>
                            <Grid item xs={2}>
                                <Button
                                    variant='contained'
                                    type='reset'
                                    className='reset-button'
                                    startIcon={<Clear/>}
                                    sx={{borderRadius: '25px'}}
                                    onClick={handleClean}
                                >Limpar</Button>
                            </Grid>
                            <Grid item xs={2}>
                                <Button
                                    variant='contained'
                                    type="submit"
                                    className="submit-button"
                                    endIcon={<Send/>}
                                    onClick={handleSave}
                                    sx={{borderRadius: '25px'}}
                                >{id === 'novo' ? 'Proximo' : 'Salvar'}</Button>
                            </Grid>
                </Grid>
                <Grid container flex={1} spacing={2} padding={1} marginTop={2}>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            label='Nome Fantasia'
                            type='text'
                            fullWidth
                            name='nome'
                            value={data?.nome}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            error={error && data.nome === ''}
                            helperText={ error && data.nome === '' ? 'É necessario preencher este campo' : null}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            label='Razão Social'
                            type='text'
                            fullWidth
                            name='company_name'
                            value={data?.company_name}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            error={error && data.company_name === ''}
                            helperText={ error && data.company_name === '' ? 'É necessario preencher este campo' : null}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            label='E-mail'
                            type='text'
                            fullWidth
                            placeholder='exmplo@email.com'
                            name='email'
                            value={data?.email}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            error={error && data.email === ''}
                            helperText={ error && data.email === '' ? 'É necessario preencher este campo' : null}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <ReactInputMask
                            mask={'99.999.999/9999-99'}
                            value={data?.company_register}
                            name='company_register'
                            onChange={handleChange}
                        >
                            {() => 
                                <TextField
                                    label='CNPJ'
                                    type='text'
                                    fullWidth
                                    name='company_register'
                                    InputLabelProps={{ shrink: true }}
                                    error={error && data.company_register === ''}
                                    helperText={ error && data.company_register === '' ? 'É necessario preencher este campo' : null}
                                    required
                                />
                            }
                        </ReactInputMask>
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            label='Quantidade de barragens'
                            type='text'
                            fullWidth
                            name='quantidade_barragens'
                            value={data?.quantidade_barragens}
                            InputLabelProps={{ shrink: true }}
                            onChange={handleChange}
                            error={error && data.quantidade_barragens === 0}
                            helperText={ error && data.quantidade_barragens === 0 ? 'É necessario preencher este campo' : null}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            onChange={handleChange}
                            label='Site'
                            type='text'
                            value={data?.site}
                            fullWidth 
                            name='site'
                            InputLabelProps={{ shrink: true }}
                            error={error && data.site === ''}
                            helperText={ error && data.site === '' ? 'É necessario preencher este campo' : null}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <ReactInputMask
                            mask={'(99)99999-9999'}
                            value={data?.phone}
                            name='phone'
                            onChange={handleChange}
                        >
                            {() =>     
                                <TextField
                                    label='Telefone'
                                    type='text'
                                    name='phone'
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    error={error && data.phone === ''}
                                    helperText={ error && data.phone === '' ? 'É necessario preencher este campo' : null}
                                    required
                                />
                            }
                        </ReactInputMask>
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    {newForm ? 
                        <FormControlLabel
                            control={
                                <Switch
                                    name="ativo"
                                    checked={data.status}
                                    onChange={handleSwitchChange}
                                />
                            }
                            label={'Ativo'}
                        />
                    : null
                    }
                </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                        >
                            <ReactInputMask
                                mask={'99999.999'}
                                value={data?.cep}
                                name='cep'
                                onChange={handleChange}
                            >
                                {() => 
                                    <TextField
                                        label='CEP'
                                        type='text'
                                        fullWidth
                                        name='cep'
                                        InputLabelProps={{ shrink: true }}
                                        error={error && data.cep === ''}
                                        helperText={ error && data.cep === '' ? 'É necessario preencher este campo' : null}
                                        required
                                    />
                                 }
                            </ReactInputMask>
                            <IconButton
                                onClick={fetchAdress}
                            >
                                <Search/>
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Rua'
                        type='text'
                        value={data?.rua}
                        fullWidth 
                        name='rua'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.rua === ''}
                        helperText={ error && data.rua === '' ? 'É necessario preencher este campo' : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Bairro'
                        type='text'
                        value={data?.bairro}
                        fullWidth
                        name='bairro'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.bairro === ''}
                        helperText={ error && data.bairro === '' ? 'É necessario preencher este campo' : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Número'
                        type='text'
                        value={data?.numero}
                        fullWidth
                        name='numero'
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Complemento'
                        type='text'
                        value={data?.complemento}
                        fullWidth
                        name='complemento'
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Cidade'
                        type='text'
                        value={data?.cidade}
                        fullWidth
                        name='cidade'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.cidade === ''}
                        helperText={ error && data.cidade === '' ? 'É necessario preencher este campo' : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='Estado'
                        type='text'
                        value={data?.estado}
                        fullWidth   
                        name='estado'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.estado === ''}
                        helperText={ error && data.estado === '' ? 'É necessario preencher este campo' : null}
                        required
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        onChange={handleChange}
                        label='País'
                        type='text'
                        value={data?.pais}
                        fullWidth
                        name='pais'
                        InputLabelProps={{ shrink: true }}
                        error={error && data.pais === ''}
                        helperText={ error && data.pais === '' ? 'É necessario preencher este campo' : null}
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider/>
                </Grid>
                <Grid item xs={12}>
                    <Box display={'flex'} flexDirection={'column'} alignItems={ 'center'}>
                        <Typography>Logo da empresa </Typography>
                        <Button component="label" role={undefined} variant="contained" tabIndex={-1} startIcon={<UploadFile />} htmlFor="file-input">
                            Upload file
                            <input id="file-input" type="file" onChange={handleFileChange} hidden />
                        </Button>
                    </Box>
                </Grid>
                    {data.image ? 
                        <Grid item xs={12} display={'flex'} justifyContent={'center'} alignContent={'center'} flexDirection={'column'}>
                            <Box display={'flex'} flexDirection={'column'} alignItems={ 'center'}>
                                    <Typography textAlign={'center'}>Imagem</Typography>
                                    <Box 
                                        sx={{ 
                                            border: '2px solid grey', 
                                            flex: 1, 
                                            borderRadius: 2, 
                                            display: 'flex', 
                                            justifyContent: 'center', 
                                            alignItems: 'center', 
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <img
                                            src={imageSrc}
                                            alt="Logo"
                                            style={{
                                            width: '100%',
                                            height: '50',
                                            objectFit: 'contain',
                                            }}
                                        />
                                    </Box>
                            </Box>
                        </Grid>
                        : null
                     }
                </Grid>
                
        </Box>
    );
};